import React from "react";
import "./Fellows.css";
import fellowsHero from "../assets/fellow.jpg";

const FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLScKyXEhY2U6CgObLVEJ1xGEOwa6uLtNcyJf_17vMKsL0lG_OQ/viewform?usp=header";

export default function Fellows() {
  return (
    <main className="fellows">
      <section className="fellowsHero" aria-label="WPark Fellows">
        <div className="fellowsWrap">
          <div className="fellowsHero__grid">
            <div className="fellowsHero__media">
              <img
                src={fellowsHero}
                alt="Mabel speaking with guests at a WPark community event"
                className="fellowsHero__img"
              />
            </div>

            <div className="fellowsHero__content">
              <div className="fellowsMini">WPARK COMMUNITY</div>

              <h1 className="fellowsHero__title">
                FUTURE
                <br />
                MOBILITY
                <br />
                FELLOWS
              </h1>

              <p className="fellowsHero__sub">
                A simple programme for students and early-career builders who care
                about AI, autonomy, mobility, and the future of real-world systems.
              </p>

              <div className="fellowsHero__cta">
                <a
                  className="fellowsBtn"
                  href={FORM_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  Apply now →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fellowsNote" aria-label="A note from Mabel">
        <div className="fellowsWrap">
          <div className="fellowsNote__panel">
            <div className="fellowsNote__left">
              <div className="fellowsMini">A NOTE FROM MABEL</div>
              <div className="fellowsNote__role">COO · WPARK 


                <br />
                <br />
                <br />
                Ex-Amazon | Ex-Rolls-Royce| Ex-Citibank
              </div>

            </div>

            <div className="fellowsNote__right">
              <p className="fellowsNote__text">
                We started this programme because some of the most thoughtful
                people we’ve met were still early in their journey — students,
                researchers, and young builders who cared deeply about how
                technology should shape the real world.
              </p>

              <p className="fellowsNote__text">
                WPark sits at the intersection of AI, autonomy, mobility, and
                systems thinking. If that excites you, I’d love for you to join
                us and grow with us.
        
        <br />
        < br />
               The Fellows programme is for people who want to learn,
                contribute, and be part of that journey — through community
                building, feedback, events, research, or early-stage startup
                exposure.
              </p>

            </div>
          </div>
        </div>
      </section>

      <section className="fellowsSection">
        <div className="fellowsWrap">
          <div className="fellowsDivider">
            <div className="fellowsMini">MISSION DRIVEN</div>
            <div className="fellowsRule" />
          </div>

          <div className="fellowsIntroSlim">
            <div className="fellowsIntroSlim__left">
              <div className="fellowsMini">ABOUT</div>
              <h2 className="fellowsH2 fellowsH2--large">
                HELP SHAPE THE FUTURE OF
                MOBILITY.
              </h2>
            </div>

            <div className="fellowsIntroSlim__right">
            </div>
          </div>

          <div className="fellowsLines">
            <div className="fellowsLineItem">
              <div className="fellowsLineItem__kicker">WHO</div>
              <div className="fellowsLineItem__title">
                Students &amp; early builders
              </div>
              <div className="fellowsLineItem__text">
                People interested in AI, robotics, autonomy, operations,
                product, mobility, or startup building.
              </div>
            </div>

            <div className="fellowsLineItem">
              <div className="fellowsLineItem__kicker">WHAT</div>
              <div className="fellowsLineItem__title">Represent &amp; contribute</div>
              <div className="fellowsLineItem__text">
                Help grow the WPark community, bring ideas and feedback, and
                support conversations around future mobility.
              </div>
            </div>

            <div className="fellowsLineItem">
              <div className="fellowsLineItem__kicker">WHY</div>
              <div className="fellowsLineItem__title">Access &amp; exposure</div>
              <div className="fellowsLineItem__text">
                Gain direct exposure to a Cambridge deep-tech startup and
                priority consideration for future opportunities.
              </div>
            </div>
          </div>

          <div className="fellowsApply">
            <div className="fellowsApply__inner">
              <div className="fellowsMini">HOW TO APPLY</div>
              <h2 className="fellowsH2">ONE SHORT FORM.</h2>
              <p className="fellowsCopy fellowsCopy--single">
                If you’re interested, apply through the online form and tell us
                a little about yourself, your background, and why WPark
                interests you.
              </p>

              <div className="fellowsApply__cta">
                <a
                  className="fellowsBtn"
                  href={FORM_URL}
                  target="_blank"
                  rel="noreferrer"
                >
                  Open application form →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}